import { useContext, useEffect } from "react";
import { GlobalContext } from "./context";
import locale from "antd/lib/locale/mn_MN";
import { ConfigProvider } from "antd";
import { Routes, Route } from "react-router-dom";
import { Home } from "./containers";
import { Banner } from "./components";
const Index = () => {
  const context = useContext(GlobalContext);

  useEffect(() => {
    localStorage.setItem("collect", JSON.stringify(context?.collect));
  }, [context?.collect]);

  useEffect(() => {
    const handleTouchMove = (e) => {
      if (e.touches.length > 1) {
        e.preventDefault();
      }
    };
    document.addEventListener("touchmove", handleTouchMove, { passive: false });

    const handleDoubleClick = (e) => {
      e.preventDefault();
    };
    document.addEventListener("dblclick", handleDoubleClick);

    return () => {
      document.removeEventListener("touchmove", handleTouchMove);
      document.removeEventListener("dblclick", handleDoubleClick);
    };
  }, []);

  return (
    <ConfigProvider
      locale={locale}
      theme={{
        token: {
          colorPrimary: "#142255",
          fontFamily: "Roboto, sans-serif",
        },
      }}
    >
      <div className="flex flex-col justify-between items-center h-screen font-roboto">
        <Banner {...context} />
        <div className="h-full w-full flex justify-center">
          <Routes>
            <Route path="/" element={<Home {...context} />} />
          </Routes>
        </div>
        <div className="bg-primary w-full flex items-center justify-center py-2 rounded-t-md">
          <span className="text-white text-sm7826">Automotive 2024</span>
        </div>
      </div>
    </ConfigProvider>
  );
};

export default Index;
